import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { withVariants } from './util';
const Small = (_jsxs("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" }, { children: [_jsx("path", { fill: "currentColor", d: "M10.73 9.48V1.32A.71.71 0 0010 .61a.7.7 0 00-.7.71v8.16L7 7.16a.72.72 0 00-1 0 .7.7 0 000 1l3.52 3.52a.7.7 0 001 0l3.53-3.52a.71.71 0 00-1-1z" }, void 0), _jsx("path", { fill: "currentColor", d: "M19.61 16.88V8.62A.63.63 0 0019 8a.64.64 0 00-.64.63v8.26a1.24 1.24 0 01-1.23 1.24h-14a1.24 1.24 0 01-1.23-1.24V8.62A.64.64 0 001.24 8a.63.63 0 00-.63.63v8.26a2.5 2.5 0 002.5 2.51h14a2.5 2.5 0 002.5-2.52z" }, void 0)] }), void 0));
export const variants = {
    small: Small,
    default: Small,
};
export default withVariants(variants);
